// Cameras: rooms whose noun is "Camera" are angles of one event, not separate
// places. Guests watch every camera on the main camera's link, with one
// guestbook and one download page, and only the main camera sends guests
// reminders and go-live emails (eventlive-cdk/lambda/rooms.ts). So an extra
// camera's own screens are short: How to Go Live, its video, delete (it's
// renamed on its chip, RoomSwitcher).
//
// Personal accounts get rooms only as cameras: "Add Another Camera Angle",
// on iOS and Android, and behind EXPO_PUBLIC_MULTICAM_B2C on web. An extra
// camera is its own product, CAMERA_PRODUCT, about half the 1-month event
// price whatever replay the main camera has, and it's kept as long as the
// main camera. One tap pays for every camera still locked
// (components/shared/PayWall.js).

import { Platform } from "react-native";

import { tc } from "@/localization";

// On for iOS and Android: store builds iOS 4.3.2 and Android 4.3.8 ship with
// the stores' CAMERA_PRODUCT, and their OTA updates must keep cameras (older
// store builds have another runtime fingerprint, so this never reaches them).
// Web needs the build-time flag set to "true".
export const multicamOn = (os, flag) =>
  flag === "true" || os === "ios" || os === "android";

// Expo inlines EXPO_PUBLIC_* values at build time, so keep the direct
// reference.
export const MULTICAM_B2C = multicamOn(
  Platform.OS,
  process.env.EXPO_PUBLIC_MULTICAM_B2C
);

export const CAMERA_NOUN = "Camera";
// The App Store, Google Play and evt.live product an extra camera is sold
// as (eventlive-cdk lambda/storageExpiry.ts, evt.live lib/cameraCheckout.cjs).
export const CAMERA_PRODUCT = "events_extra_camera";
// Cameras per event for personal accounts, the main one included.
export const MAX_CAMERAS = 3;

export const isPersonal = (auth) => auth?.account_type !== "business";

export const isCameraGroup = (event) => event?.room_noun === CAMERA_NOUN;

// A camera other than the main one.
export const isExtraCamera = (event) =>
  !!event?.room_of && isCameraGroup(event);

// Personal accounts add cameras rather than rooms.
export const addsCameras = (auth, multicam = MULTICAM_B2C) =>
  multicam && isPersonal(auth);

// The main camera's replay tiers. Its cameras are kept as long as it is. The
// length reads "the same 1-year replay" (AddRoomPane), in the app's language.
const TIER_LENGTHS = {
  events_storage_1m: () => tc("replay length", "1-month"),
  events_storage_1y: () => tc("replay length", "1-year"),
  events_storage_10y: () => tc("replay length", "10-year"),
};
export const DEFAULT_CAMERA_TIER = "events_storage_1y";

// The tier the main camera was bought at, or null (a credit, a waiver, an
// older product): then the default tier stands in for it where a replay
// length is shown.
export const cameraTierOf = (primary) =>
  [primary?.storage_tier, primary?.unlock_product_name].find(
    (tier) => !!TIER_LENGTHS[tier]
  ) || null;

export const tierLengthOf = (tier) =>
  TIER_LENGTHS[tier] ? TIER_LENGTHS[tier]() : null;
